import { render } from "./Collaboration.vue?vue&type=template&id=625cb00c"
import script from "./Collaboration.vue?vue&type=script&lang=js"
export * from "./Collaboration.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__